import React, { useMemo } from "react";
import { Avatar, Box } from "@mui/material";
import { createAvatar } from "@dicebear/core";
import * as collection from "@dicebear/collection";

const transformToDicebearConfig = (config) =>
  Object.fromEntries(Object.entries(config).map(([k, v]) => [k, [v]]));

const AvatarPreview = ({ avatarStyle, customOptions, seed }) => {
  const avatar = useMemo(() => {
    return createAvatar(collection[avatarStyle], {
      ...transformToDicebearConfig(customOptions),
      seed,
    });
  }, [avatarStyle, seed, customOptions]);

  const svgUri = useMemo(
    () => `data:image/svg+xml;utf8,${encodeURIComponent(avatar.toString())}`,
    [avatar]
  );
  return (
    <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
      <Avatar
        src={svgUri}
        alt="DiceBear Avatar"
        sx={{ width: "7rem", height: "7rem", bgcolor: "grey.200" }}
      />
    </Box>
  );
};

export default AvatarPreview;
